import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
// import { orderedArraysEqual } from "../../../util/utils";
import { DraggableEditorItem } from './draggable-editor-item';

// Modified React DnD Example code below

// React DnD Draggable Item: http://react-dnd.github.io/react-dnd/docs/overview#items-and-types
export interface DraggableEditorOption {
  id: number;
  element: JSX.Element | string;
  control?: JSX.Element;
}

interface DnDContainerProps {
  draggableOptions: DraggableEditorOption[];
  onMove(draggableOptions: DraggableEditorOption[]): void;
}

// This version of DnDContainer supports dynamic updates of option counts - if
// the # of options in the prop differ from the # in the state, state is updated.
// We don't look at the individual IDs because that will just reset to the start...
export const DnDContainer: React.FC<DnDContainerProps> = ({ draggableOptions, onMove }) => {
  const [optionState, setOptions] = React.useState(draggableOptions);

  const moveItem = React.useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const newState = [...optionState];
      // Remove the dragged option from the list...
      const dragItem = newState.splice(dragIndex, 1)[0];
      // And insert it after the card that's hovered over
      newState.splice(hoverIndex, 0, dragItem);
      setOptions(newState);
      onMove(newState);
    },
    [optionState]
  );

  const renderDraggableEditorItem = (item: DraggableEditorOption, index: number) => {
    return (
      <DraggableEditorItem
        key={item.id}
        index={index}
        id={item.id}
        element={item.element}
        control={item.control}
        moveItem={moveItem}
      />
    );
  };

  // Update the options with the new options
  const updateOptions = React.useCallback(
    (newOptions: DraggableEditorOption[]) => {
      // const updatedState = [...optionState];
      //const deletedItem =
      // updatedState.splice(itemIndex, 1)[0];
      // setOptions(updatedState);
      setOptions(newOptions);
      // if (onDelete) { onDelete(itemIndex); }
    },
    [optionState]
  );

  // // Check the lists of IDs for equality and update if changed before rendering
  // if (!orderedArraysEqual(optionState.map(opt => opt.id), draggableOptions.map(opt => opt.id))) {
  //     updateOptions(draggableOptions);
  // }
  if (optionState.length !== draggableOptions.length) {
    updateOptions(draggableOptions);
  }
  return (
    <DndProvider backend={HTML5Backend}>
      <div>{optionState.map(renderDraggableEditorItem)}</div>
    </DndProvider>
  );
};



// WEBPACK FOOTER //
// ./src/admin/ui/components/drag-and-drop/drag-and-drop-container.tsx